export default __webpack_public_path__ + "static/media/learn.335bf8fe.jpeg";